
export function handleError(error) {
    return Promise.reject(error && error.message);
}